import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect/es';

import LiveClassGroups from '../../domain/services/bbb/meeting/liveClassGroups';

const initialState = {
  loading: '',
  error: '',
  groups: [],
};

export const teacherRemoveGroupBYId = createAsyncThunk(
  'create-groups-for-teacher-by-lesson-id',
  async (id: string) => {
    return new LiveClassGroups().removeGroups({
      _eq: id,
    });
  }
);

const TeacherRemoveGroups = createSlice({
  name: 'teacher-groups-live-class/create',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(teacherRemoveGroupBYId.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(teacherRemoveGroupBYId.fulfilled, state => {
      state.loading = 'success';
    });
    builder.addCase(teacherRemoveGroupBYId.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const stateExport = state => state.teacherRemoveGroupsSlice;

export const teacherRemoveGroupState = createSelector(stateExport, obj => {
  return {
    loadingGroupDeleteGroup: obj.loading,
  };
});

export default TeacherRemoveGroups.reducer;
